import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import { searchProjects } from './api_project';
import { projectsGridConfig } from '../../pages/ProjectView/config';
import { opcoRef } from '../../components/constant';
export const initialState = {
  projectList: {
    data: [],
    field: [],
    totalCount: 0,
  },
  pageParams: {
    page: 1,
    pageSize: projectsGridConfig.pageSize,
  },
  searchReq:{
    searchKey:'',
    idVal: '',
    opco: '',
    status:'',
  }
};

export const fetchProjectsData = createAsyncThunk(
  'ui/fetchProjectsData',
  async (obj=null, thunkAPI) => {
    const { getState } = thunkAPI;
    const { projects } = getState();
    let data = obj || projects.searchReq
  
    const reqObj = {
      apP_NB:data.searchKey === 'Application Number' ? data.idVal : '',
      project_NB: data.searchKey === 'Project Number' ? data.idVal : '',
      premise_NB: data.searchKey === 'Premises Number' ? data.idVal : '',
      account_NB: data.searchKey === 'Account Number' ? data.idVal : '',
      ezID: data.searchKey === 'EZ Id' ? data.idVal : '',
      meter_NB: data.searchKey === 'Meter Number' ? data.idVal : '',
      opco: opcoRef?.[data.opco],
      app_Type: data.searchKey === 'Application Type' ?data.appType: '',
      status: data.status,
    };
    const response = await searchProjects(reqObj, projects.pageParams);
    return response.data;
  }
);

const searchProjectsSlice = createSlice({
  name: 'projects',
  initialState,
  reducers: {
    resetSearchDataReducer: () => initialState,
    setPageParams: (state, action) => {
      state.pageParams = action.payload;
    },
    setSearchParams: (state, action) => {
      state.searchReq = action.payload;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchProjectsData.pending, (state) => {
        return {
          ...state,
          status: 'loading',
          searchProjectsLoaded: false,
          searchProjectsFetchFailed: false,
          searchProjects: initialState.projectList,
        };
      })
      .addCase(fetchProjectsData.fulfilled, (state, action) => {
        return {
          ...state,
          status: 'idle',
          searchProjects: action.payload,
          searchProjectsFetchFailed: false,
          searchProjectsLoaded: true,
        };
      })
      .addCase(fetchProjectsData.rejected, (state) => {
        return {
          ...state,
          searchProjectsFetchFailed: true,
          status: 'idle',
          searchProjectsLoaded: true,
          searchProjects: initialState.projectList,
        };
      });
  },
});

export const getSearchData = (state) => state.projects?.searchProjects;
export const getSearchStatus = (state) => state.projects?.status;
export const getPageParams = (state) => state.projects?.pageParams;
export const getSearchParams = (state) => state.projects?.searchReq;


export const { resetSearchDataReducer, setPageParams,setSearchParams } =
  searchProjectsSlice.actions;
export default searchProjectsSlice.reducer;
